import script from "./TheFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheFooter.vue?vue&type=script&setup=true&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=181fc20a&lang=scss"

const __exports__ = script;

export default __exports__